
/**
 * Module dependencies.
 */

var pattern = /(\w+)\[(\d+)\]/

/**
 * Safely encode the given string
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

var encode = function(str) {
  try {
    return encodeURIComponent(str)
  } catch (e) {
    return str
  }
}

/**
 * Safely decode the string
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

var decode = function(str) {
  try {
    return decodeURIComponent(str.replace(/\+/g, ' '))
  } catch (e) {
    return str
  }
}

/**
 * Parse the given query `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api public
 */
export function parse(str){
  if ('string' != typeof str) return {}

  if ('' == str) return {}
  if ('?' == str.charAt(0)) str = str.slice(1)

  var obj = {}
  var pairs = str.split('&')
  for (var i = 0; i < pairs.length; i++) {
    var parts = pairs[i].split('=')
    var key = decode(parts[0])
    var m

    if (m = pattern.exec(key)) { // eslint-disable-line
      obj[m[1]] = obj[m[1]] || []
      obj[m[1]][m[2]] = decode(parts[1])
      continue
    }

    obj[parts[0]] = null == parts[1]
      ? ''
      : decode(parts[1])
  }

  return obj
}

/**
 * Stringify the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api public
 */

export function stringify(obj) {
  if (!obj) return ''
  var pairs = []
  for (var key in obj) {
    var value = obj[key]

    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; ++i) {
        pairs.push(key + '[]' + '=' + encode(value[i]))
      }
      continue
    }

    pairs.push(key + '=' + encode(obj[key]))
  }

  return pairs.join('&')
}
